export const passwordRegex = /^.{7,}\S$/;
export const userNameRegex = /^[a-zA-Z0-9_]+$/;
